
export const environment = {
  production: false,
// DEV
AuthServer: 'https://tmx-finance-dev-auth.azurewebsites.net',
backend: 'https://tmx-finance-dev-api.azurewebsites.net/api/v1/',
logo: 'assets/images/samba-bank.jpg',
banner:'assets/images/Samba-Banner.png',
// QA
// AuthServer:'https://tmx-finance-qa-auth.azurewebsites.net',
// backend: 'https://tmx-finance-qa-api.azurewebsites.net/api/'  ,
// logo:'/assets/images/samba bank.jpg'
Environment:'DEV'
};


